import location from '../../assets/icons/location.png'
import phone from '../../assets/icons/telephone-call.png'
import mail from '../../assets/icons/mail.png'
import ValueBox from "./ValueBox"
import { CONTACT_PAGE } from '../../data/texts'

const Values = () => {

    const data = CONTACT_PAGE
    
    return(
        <div className='flex flex-col gap-8 lg:w-1/3'>
                   <ValueBox
                   img={location}
                   title={'آدرس'}
                   text={data.address}                   
                   />
                   <ValueBox
                   img={phone}
                   title={'شماره تماس'}
                   name1={data.phoneName1}
                   name2={data.phoneName2}
                   option1={data.phone1}
                   option2={data.phone2}
                   />
                   <ValueBox
                   img={mail}
                   title={'ایمیل'}
                   option1={data.email1}
                   option2={data.email2}
                   />
               </div>
    )
}
export default Values